<template>
<div>
<HomeLayout isHome="true" bg_icon='fyiio' v-if="$mq === 'md'">
  <h2> discover what better tutorials look + feel like with fyiio</h2>
  <div class="alert alert-danger" v-if="error">
      <p v-if="error" class="error">{{ error.message }}</p>
  </div>
  <form @submit.prevent="signup" autocomplete="off">
      <div class="row register-form">

          <div class="input-field col s6">
              <input type="text"  placeholder="email" v-model="email" autocomplete="off"  required>
          </div>
          <div class="input-field col s6">

              <input type="password" class="password" placeholder="password" v-model="pass" autocomplete="off" @input="password_check" required>
              <div class="password-strength-wrapper" v-html="passwordStrengthMessage"></div>

          </div>
          <div class="input-field col s6">
              <input type="text"  placeholder="company/organization" v-model="organization" autocomplete="off" required>
          </div>
          <div class="input-field col s6">
              <input type="text"  placeholder="name" v-model="name" autocomplete="off" required>
          </div>
          <p class='start-tos-row'>
            <button class="btn blue trial-btn col s3">START FOR FREE</button>


            <label>
              <input type="checkbox" v-model="tos_checked" @change="toggleTosNeeded"/>
              <span>i accept fyiio's
                      <a href="#pmodal" class="modal-trigger">privacy policy</a>
                      + <a href="#tosmodal" class="modal-trigger">terms of service</a></span>
            </label>
            <div v-if="this.tos_needed" class="tos-needed">You must agree to our privacy policy and terms of service before continuing.</div>
          </p>
      </div>

      <p class="message">no credit card required because literally everyone hates that<br/>we do hope you pay us eventually</p>
  </form>
</HomeLayout>
<MobileLayout isHome="true" v-if="$mq === 'sm'" class='home'>
  <h1 class="intro white-text">
    better tutorials are <br/>
    made with fyiio
  </h1>
  <div class="row text-center">
    <router-link to="signup" class="btn blue signup">
      Start For Free
    </router-link>
  </div>
</MobileLayout>
</div>
</template>


<script>
import HomeLayout from '@/containers/layouts/HomeLayout'
import MobileLayout from '@/containers/layouts/MobileLayout'

export default {
  data () {
    return {
      username: '',
      email: '',
      pass: '',
      name: '',
      organization: '',
      error: null,
      has_number:    false,
      has_lowercase: false,
      has_uppercase: false,
      has_special:   false,
      has_length: false,
      tos_checked: false,
      tos_needed: false
    }
  },
  mounted () {
        M.AutoInit();

  },
  methods: {
    toggleTosNeeded() {
      this.tos_needed = false;
    },
    signup () {
      if (!this.tos_checked) {
        this.tos_needed = true;
        return
      }
      var username = this.email;
      var attributes = {
        username: username,
        name: this.name,
        organization: this.organization,

      }
      this.$cognitoAuth.signup(this.email, this.pass, attributes, (err, result) => {
        if (err) {
          if (err.code == 'InvalidParameterException') {
            this.error = {message: "Please enter a valid email address and strong password"}
          } else {
            this.error = err
          }
        } else {
          setTimeout(function(){}, 1000)
          this.$router.replace({path: '/confirm', query: {username: this.email}})
        }
      })
    },
    password_check () {
        this.has_number    = /\d/.test(this.pass);
        this.has_lowercase = /[a-z]/.test(this.pass);
        this.has_uppercase = /[A-Z]/.test(this.pass);
        this.has_special   = /[!@#\$%\^\&*\)\(+=._-]/.test(this.pass);
        this.has_length = this.pass.length > 7;
    },
  },
  computed: {
    passwordStrength: function() {
      var strength = 0;
      if (this.has_number) strength++;
      if (this.has_lowercase) strength++;
      if (this.has_uppercase) strength++;
      if (this.has_special) strength++;
      if (this.has_length) strength++;
      return strength;
    },
    passwordMessage: function() {
      var message = "";
      if (this.passwordStrength > 4) {
        message = "Your password is very strong!"
      } else {
        message = "To stengthen your password, please: "
        var messages = [];
        if (!this.has_number) messages.push("include a number")
        if (!this.has_lowercase) messages.push("include a lower case letter")
        if (!this.has_uppercase) messages.push("include an upper case letter")
        if (!this.has_special) messages.push("include a special character")
        if (!this.has_length) messages.push("use more than 8 characters")
        message += messages.join(", ")
      }
      return message;
    },
    passwordStrengthMessage: function() {
      if (this.passwordStrength < 1) {
        return "";
      } else if (this.passwordStrength < 3) {
        return '<div class="passwordStrength weak" title="'+this.passwordMessage+'">weak</div>'
      } else if (this.passwordStrength < 4) {
        return '<div class="passwordStrength medium" title="'+this.passwordMessage+'">medium</div>'
      } else if (this.passwordStrength < 5) {
        return '<div class="passwordStrength strong" title="'+this.passwordMessage+'">strong</div>'
      } else  {
        return '<div class="passwordStrength strong" title="'+this.passwordMessage+'">strong</div>'
      }
    }
  },
  components: {
    HomeLayout, MobileLayout
  }
}
</script>

<style scoped>
.error {
  color: red;
}
.passwordStrength {
  text-align: right;
  display: inline-block;
  padding-top: 2px;
  padding-bottom: 2px;
  padding-right: 5px;
  padding-left: 5px;
  opacity: 0.5;
}
.passwordStrength .weak {
  background-color: red;
}
.passwordStrength .medium {
  background-color: orange;
}
.passwordStrength .strong {
  background-color: green;
}
.password-strength-wrapper {
  position: absolute;
  right: 10px;
  top: 10px;
}
.password {
  padding-right: 150px;
}
.register-form {
  font-weight: 300!important;
  margin-bottom: 0px;
}
.register-form input {
  border-bottom: 1px solid #9e9e9e !important;
  height: 30px;
}

.trial-btn {
  margin-top: 24px;
}
.trial-btn:hover {
  background-color: #00a79d!important;
}
.start-tos-row label {
  margin-top: 20px;
  margin-left: 14px;
  display: inline-block;
  color: #939598;
  font-size: 8px!important;
}
.start-tos-row input {
  margin-right: 0px;
}
.start-tos-row a {
  color: #27aae1;
}
.start-tos-row .btn {
  width: 175px;
  color: white!important;
}
[type="checkbox"] + span:not(.lever) {
  font-size: 14px;
}

.tos-needed {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/containers/Home.vue